import { manufacturingFetch } from "@/lib/manufacturingClient";

const PATH = "/api/mfg/builder-assistant";

function post<T>(body: Record<string, unknown>) {
  return manufacturingFetch<T>(PATH, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(body),
  });
}

export type QcStoredPhoto = { id: string; url: string };

async function urlsOf(
  res: Promise<{ ok: true; data: { url?: string | null; photos?: QcStoredPhoto[] } } | { ok: false; error: string }>,
): Promise<{ ok: true; urls: string[] } | { ok: false; error: string }> {
  const listed = await res;
  if (!listed.ok) return listed;
  if (listed.data.photos) return { ok: true, urls: listed.data.photos.map((photo) => photo.url).filter(Boolean) };
  return { ok: true, urls: listed.data.url ? [listed.data.url] : [] };
}

export function loadQcExample(itemId: string) {
  return urlsOf(post({ op: "checklist-example-url", item_id: itemId }));
}

export function loadQcPassPhoto(sessionId: string, itemId: string) {
  return urlsOf(post({ op: "checklist-pass-url", session_id: sessionId, item_id: itemId }));
}

export function loadQcObservationPhotos(observationId: string, caption: "failure" | "fix") {
  return post<{ ok: true; photos: QcStoredPhoto[] }>({
    op: "checklist-observation-photos",
    observation_id: observationId,
    caption,
  });
}
